<template>
    <div :key="submissionKey">

        <div v-if="$route.meta.isPublicView || user">
            <va-page-header>

                <div slot="title">
                    <va-button class="back_button" @click.native="$router.go(-1)" type="default" size="lg">
                        <va-icon type="chevron-left"></va-icon>
                    </va-button>
                    <span v-if="viewedForm">{{ g_getSurveyFieldStuffWithThisPrefix({'englishLabel': viewedForm.get('label_english'),
                            'pashtoLabel': viewedForm.get('label_pashto'),'dariLabel': viewedForm.get('label_dari'),},
                        submittedLanguage, 'Label', formLanguages) }}</span>
                    <span
                        v-if="!$route.meta.isPublicView && viewedForm && viewedSubmission && viewedForm.submissionApprovers && viewedForm.submissionApprovers.length != 0"
                        class='status'>{{ _(viewedSubmission.get('status')) }}</span>
                </div>

                <div slot="actions" v-if="!$route.meta.isPublicView">

                    <va-button size="lg" type="danger" @click.native="rejectObject"
                        v-if="viewedForm && viewedSubmission && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || (user.get('roles').includes('survey-editor') && isSubmissionApprover) || (user.get('roles').includes('submission-approver') && isSubmissionApprover)) && viewedSubmission.get('status') == 'pending' && viewedForm.submissionApprovers.length != 0">
                        {{ _('REJECT') }}
                    </va-button>
                    <va-button size="lg" type="info" @click.native="approveObject"
                        v-if="viewedForm && viewedSubmission && (user.get('roles').includes('admin')  || user.get('roles').includes('manager') || (user.get('roles').includes('survey-editor') && isSubmissionApprover) || (user.get('roles').includes('submission-approver') && isSubmissionApprover)) && viewedSubmission.get('status') == 'pending' && viewedForm.submissionApprovers.length != 0">
                        {{ _('APPROVE') }}
                    </va-button>
                    <va-button size="lg" type="primary"
                        @click.native="$router.push('/surveys/' + $route.params.scope + '/' + $route.params.category + '/' + $route.params.form_slug + '/data_submitter/' + viewedSubmission.id)"
                        v-if="viewedForm && viewedSubmission && (user.get('roles').includes('admin')  || user.get('roles').includes('manager') || (viewedSubmission.get('createdBy') && viewedSubmission.get('createdBy').id == user.id))">
                        {{ _('Edit') }}
                    </va-button>
                </div>

            </va-page-header>

            <va-form type="vertical" ref="form">
                <va-row :class="{form_rtl: submittedLanguage != 'english', form_ltr: submittedLanguage == 'english'}"
                    :gutter="12" class="tabContent" style="margin-left:0">

                    <va-column :lg="12" :md="12" :sm="12" :xs="12" style="padding-top: 10px"
                        v-if="viewedSubmission != null">

                        <div v-if="!$route.meta.isPublicView">
                            <div style="display: flex; align-items: center">
                                <div>
                                    <img width="32px" height="32px" style="border-radius: 100px; margin-right: 10px"
                                        v-if="viewedSubmission.get('createdBy') && viewedSubmission.get('createdBy').get('profilePic')"
                                        :src="viewedSubmission.get('createdBy').get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')"
                                        alt="profile picture">
                                    <img width="32px" height="32px" style="border-radius: 100px; margin-right: 10px"
                                        v-else src="@/assets/emptyProfile.jpg" alt="profile picture">
                                </div>
                                <div style="display: flex; flex-direction: column;">
                                    <span
                                        v-if="viewedSubmission.get('createdBy')">{{ viewedSubmission.get('createdBy').get('name') }}</span>
                                    <span style="color: gray;">{{ _('submitter') }}</span>
                                </div>
                            </div>
                            <div v-if="viewedSubmission.get('approvalBy')"
                                style="display: flex; align-items: center; margin: 10px 0">
                                <img width="32px" height="32px" style="border-radius: 100px; margin-right: 10px"
                                    v-if="viewedSubmission.get('approvalBy') && viewedSubmission.get('approvalBy').get('profilePic')"
                                    :src="viewedSubmission.get('approvalBy').get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')"
                                    alt="profile picture">
                                <img width="32px" height="32px" style="border-radius: 100px; margin-right: 10px" v-else
                                    src="@/assets/emptyProfile.jpg" alt="profile picture">
                                <span
                                    v-if="viewedSubmission.get('approvalBy')">{{ viewedSubmission.get('approvalBy').get('name') }}</span>
                                <span class="field_label"> <span style="padding: 0 10px">|</span>
                                    {{ _('approver') }}</span>
                            </div>
                        </div>
                        <span class="field_label">{{ _('Submitted in') }}:
                            {{ viewedSubmission.get('submission_language') }}</span>
                        <hr>
                        <div v-for="prop in props">
                            <va-row :gutter="12" style="margin: 0">
                                <va-column :md="8">
                                    <span class="field_label">
                                        {{ getFieldLabel(prop.name) }}
                                    </span>
                                    <span class="field-value"
                                        v-if="prop.type != 'attachment' && prop.type != 'single-geolocation' && prop.type != 'multiple-geolocation'">{{
                                        getValue(prop) }}</span>
                                    <div
                                        v-if="prop.type == 'single-geolocation' || prop.type == 'multiple-geolocation'">

                                        <GmapMap :center="{lat:34.55, lng:69.20}" :zoom="8" map-type-id="terrain"
                                            style="max-width:600px; width: 300px;  height: 300px; padding: 0; margin: 0">
                                            <GmapMarker v-if="prop.type == 'multiple-geolocation'" :key="index"
                                                v-for="(m, index) in getValue(prop)" :position="m.position"
                                                @click="center=m.position" />
                                            <GmapMarker v-if="prop.type=='single-geolocation'" :position="prop.value"
                                                @click="center=m.position" />
                                        </GmapMap>
                                        <br>
                                    </div>
                                    <div v-if="prop.type == 'attachment'">
                                        <div v-if="Array.isArray(prop.value)">
                                            <div v-for="(file, index) in prop.value"
                                                style="display: flex; flex-direction: row; margin-right: 8px; ">
                                                <div style="display:flex; flex-direction: column">
                                                    <div class="file_chip">
                                                        <span class="file-text file_view">{{
                                                            getFileName(file)
                                                            }}</span>
                                                        <a v-if="$route.meta.isPublicView" target="_blank"
                                                            class="file_download" :href="file" :download="file">
                                                            <va-icon class="file_download_icon" type="download"
                                                                size=".8em">
                                                            </va-icon>
                                                        </a>

                                                        <span v-else-if="user && !$route.meta.isPublicView"
                                                            class="file_download">
                                                            <va-icon color="blue" class="file_download_icon"
                                                                type="download" size=".8em"
                                                                @click.native="sendEmail({to: user.get('username'), subject: 'Survey: ' + viewedForm.get('label_' + viewedSubmission.get('submission_language')) + ', attachment download', text: 'You can download the requested attachment from this link: ' + file})">
                                                            </va-icon>
                                                        </span>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div style="display: flex; flex-direction: row; margin-right: 8px; ">
                                                <div style="display:flex; flex-direction: column">
                                                    <div class="file_chip">
                                                        <!-- <a target="_blank" :href="prop.value"
                                                            class="file-text file_view">{{
                                                            getFileName(prop.value)
                                                            }}</a> -->
                                                        <span class="file-text file_view">{{
                                                                getFileName(prop.value)
                                                                }}</span>
                                                        <a v-if="$route.meta.isPublicView" target="_blank"
                                                            class="file_download" :href="prop.value"
                                                            :download="prop.value">
                                                            <va-icon class="file_download_icon" type="download"
                                                                size=".8em">
                                                            </va-icon>
                                                        </a>

                                                        <span v-else-if="user && !$route.meta.isPublicView"
                                                            class="file_download">
                                                            <va-icon color="blue" class="file_download_icon"
                                                                type="download" size=".8em"
                                                                @click.native="sendEmail({to: user.get('username'), subject: 'Survey: ' + viewedForm.get('label_' + viewedSubmission.get('submission_language')) + ' attachment download', text: 'You can download the requested attachment from this link: ' + prop.value})">
                                                            </va-icon>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </va-column>
                            </va-row>
                        </div>

                    </va-column>
                </va-row>

                <va-row :gutter="12">
                    <va-column v-if="!$route.meta.isPublicView && user.get('type') != 'guest'" :lg="12" :md="12"
                        :sm="12" :xs="12" style="padding: 20px">
                        <va-card>
                            <activities :form="viewedForm" />
                        </va-card>
                    </va-column>
                </va-row>
            </va-form>
        </div>

    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import Activities from '../Activities.vue'
    import moment from 'moment';
    import momentJalali from 'jalali-moment';



    export default {

        components: {
            Activities
        },

        data() {
            return {
                submissionId: this.$route.params.id,
                submission: null,
                viewedSubmission: { get: () => '' },
                props: [],
                props_meta: {},
                survey: {},
                loadedAgent: {},
                fields: {},
                files_key: '',
                formLanguages: [],
                surveyNames: {},
                submissionKey: '',
                requireSubmissionApproval: '',
                submissionStatus: '',
                viewedForm: { get: () => '' },
                submittedLanguage: 'english'
            }
        },

        computed: {
            ...mapGetters(['user', 'getSystemLanguage']),

            isSubmissionApprover() {
                if (this.viewedForm && this.viewedForm.get('status') != 'pending') {
                    if (this.viewedForm.get("survey_submission_approvers")) {
                        for (let i = 0; i < this.viewedForm.get('survey_submission_approvers').length; i++) {
                            const approver = this.viewedForm.get('survey_submission_approvers')[i];
                            if (approver && this.user && approver.id == this.user.id) {
                                return true
                            }
                        }
                    }
                }
                return false
            },


            getSubmissionStatus() {
                if (this.viewedSubmission) {
                    return this.viewedSubmission.status
                }
            }
        },

        watch: {
            async '$route'(v) {
                await this.fetchings()
            }
        },

        methods: {
            ...mapActions(['sendNewNotification']),

            // approved
            approveObject() {
                this.g_approveObject(this.viewedSubmission)
                    .then(result => {
                        this.viewedSubmission = result
                        this.submissionKey = Date.now()

                    }).catch(e => {

                    })
            },

            rejectObject() {
                this.g_rejectObject(this.viewedSubmission)
                    .then(result => {
                        this.viewedSubmission = result
                        this.submissionKey = Date.now()
                    }).catch(e => {

                    })
            },

            getFieldLabel(names) {
                if (this.viewedSubmission.get('submission_language') == 'dari') return names.dari
                else if (this.viewedSubmission.get('submission_language') == 'pashto') return names.pashto
                else return names.english
            },

            getFileName(file) {
                if (file) return file.split('/')[file.split('/').length - 1]
            },

            getSurveyName(names) {
                if (this.getSystemLanguage == 'dari' && names.dari != '') return names.dari
                if (this.getSystemLanguage == 'pashto' && names.pashto != '') return names.pashto
                else return names.english
            },

            getQuestionName(names) {
                if (this.getSystemLanguage == 'dari') {
                    if (this.formLanguages.includes('dari')) return names.dari
                    else {
                        if (this.formLanguages[0] == 'pashto') return names.pashto
                        else return names.english
                    }
                }

                if (this.getSystemLanguage == 'pashto') {
                    if (this.formLanguages.includes('pashto')) return names.pashto
                    else {
                        if (this.formLanguages[0] == 'dari') return names.dari
                        else return names.english
                    }


                } else {
                    if (this.formLanguages.includes('english')) return names.english
                    else {
                        if (this.formLanguages[0] == 'pashto') return names.pashto
                        else return names.dari
                    }
                }



                // if (this.getSystemLanguage == 'dari' && names.dari != '') return names.dari
                // else if (this.getSystemLanguage == 'pashto' && names.pashto != '') return names.pashto
                // else return names.english
            },

            getFileType(filename) {

                switch (filename.substr(filename.search(/(\.)(?!.*\.)/) + 1)) {
                    case 'mp4': return 'video'
                    case 'mpg': return 'video'
                    case 'avi': return 'video'
                    case 'mpeg': return 'video'
                    case 'mkv': return 'video'
                    case '3gp': return 'video'
                    case 'm4a': return 'video'
                    case 'wmv': return 'video'
                    case 'asf': return 'video'
                    case 'm4a': return 'video'
                    case 'wav': return 'audio'
                    case 'mp3': return 'audio'
                    case 'midi': return 'audio'
                    case 'jpg': return 'image'
                    case 'jpeg': return 'image'
                    case 'bmp': return 'image'
                    case 'png': return 'image'
                    case 'tiff': return 'image'
                    case 'gif': return 'image'
                    case 'ico': return 'image'
                    case 'pdf': return 'pdf'
                }

                return 'file'
            },

            getImageUrl(file) {
                return new DB.File(file).url
            },

            changeSurveyLanguageTo(lang) {
                this.$refs.languagesDropDown.close()
                this.getSystemLanguage = lang
            },


            getValue(prop) {
                if (prop.value instanceof Date) {
                    if (prop.type == 'date') {
                        if (prop.field.isHijri) {
                            if (prop.value) {
                                var date = new Date(prop.value)
                                var stringDate = date.getFullYear() + '/' + parseInt(1 + date.getMonth()) + '/' + date.getDate()
                                return momentJalali(stringDate, 'YYYY/MM/DD').locale('fa').format('YYYY-MM-DD');
                            }
                        } else {
                            return new Date(prop.value).getFullYear() +
                                '-' + (parseInt(new Date(prop.value).getMonth()) + parseInt(1)) + '-' +
                                new
                                    Date(prop.value).getDate()
                        }
                    }
                } else if (prop.type == 'date') {
                    if (prop.field.isTime) {
                        return moment.utc(prop.value * 1000).format('HH:mm:ss')
                    }
                    return ''
                } else if (prop.type == 'select' || prop.type == 'single-option' || prop.type == 'multiple-option') {
                    if (!Array.isArray(prop.value)) prop.value = [prop.value]

                    var ret = []
                    for (var f in this.fields) {
                        if (this.fields[f].key == prop.key) {
                            if (this.fields[f].type == 'select' || this.fields[f].type == 'multiple-option' || this.fields[
                                f].type == 'single-option') {

                                for (var d in this.fields[f].options) {
                                    for (const key in prop.value) {
                                        // 
                                        if (prop.value[key] == this.fields[f].options[d].value) {
                                            // ret.push(this.fields[f].options[d].label)
                                            if (this.viewedSubmission.get('submission_language') == 'dari') ret.push(this.fields[f].options[d].dariLabel)
                                            else if (this.viewedSubmission.get('submission_language') == 'pashto') ret.push(this.fields[f].options[d].pashtoLabel)
                                            else ret.push(this.fields[f].options[d].englishLabel)
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    return ret.join(', ')
                } else if (prop.type == 'createdBy') {
                    return prop.value.name
                } else if (prop.type == 'checkbox') {
                    if (this.viewedSubmission.get('submission_language') == 'english') {
                        return prop.value ? 'Yes' : 'No'
                    } else if (this.viewedSubmission.get('submission_language') == 'pashto') {
                        return prop.value ? 'هو' : 'نه'
                    } else if (this.viewedSubmission.get('submission_language') == 'dari') {
                        return prop.value ? 'بلی' : 'نخیر'
                    }
                } else {
                    return prop.value
                }
            },

            navigate(to) {
                this.$router.replace(to);
            },

            fetchFieldAgent(agent) {
                DB.User
                    .load(agent.id, { depth: true })
                    .then(loadedAgent => {
                        this.loadedAgent = loadedAgent
                    })
            },

            async fetchSubmisison() {

                let q = new Parse.Query(this.viewedForm.get('class_name'))
                if (this.$route.params.id) this.viewedSubmission = await q.get(this.$route.params.id)
                if (this.viewedSubmission) {
                    this.submittedLanguage = this.viewedSubmission.get('submission_language')
                }

                let fields = [];
                this.viewedForm.get('layout').map(q => {
                    if (q.type !== 'heading' && q.type !== 'description') {
                        fields.push({
                            key: q.fieldDatabaseName,
                            field: q,
                            label: {
                                english: this.viewedForm.get('form_languages').includes(
                                    'english') ? q.englishLabel : '',
                                pashto: this.viewedForm.get('form_languages').includes(
                                    'pashto') ? q.pashtoLabel : '',
                                dari: this.viewedForm.get('form_languages').includes(
                                    'dari') ? q.dariLabel : ''
                            },
                            type: q.type,
                            options: q.type == 'multiple-option' || q.type ==
                                'single-option' || q.type == 'select' ? q.options : []
                        })
                    }
                });
                for (var ind in fields) {
                    if (fields[ind].type != 'single-geolocation') {
                        this.props.push({
                            name: fields[ind].label,
                            field: fields[ind].field,
                            value: this.viewedSubmission.get(fields[ind].key),
                            type: fields[ind].type,
                            key: fields[ind].key
                        })
                    } else {
                        this.props.push({
                            name: fields[ind].label,
                            field: fields[ind].field,
                            value: { lat: this.viewedSubmission.get('latitude'), lng: this.viewedSubmission.get('longitude') },
                            type: fields[ind].type,
                            key: fields[ind].key
                        })
                    }
                }

                this.fields = fields
                this.$store.commit("setLoading", false);
            },

            async fetchForm() {
                let q = new Parse.Query('Form')
                q.equalTo('class_name', 'Data_' + this.$route.params.form_slug)
                let viewedForm = await q.first()
                this.formLanguages = viewedForm.get('form_languages')
                if (!this.$route.meta.isPublicView) {
                    let submissionApprovers = viewedForm.get("survey_submission_approvers")
                    viewedForm['submissionApprovers'] = submissionApprovers
                }
                this.viewedForm = viewedForm
            },

            async fetchings() {
                this.$store.commit('setLoading', true)
                await this.fetchForm()
                await this.fetchSubmisison()
                this.$store.commit('setLoading', false)
            }
        },

        async mounted() {
            await this.fetchings();
        }

    };
</script>

<style>
    .lang_icon {
        font-size: 1.5em !important;
        margin-top: 8px !important;
    }

    .array_options {
        margin: 0 5px 0 0;
        background: #ebecf0;
        padding: 5px;
    }

    .file-text-over {
        font-size: 0.8em;
        height: 17px;
        margin-top: 4px;
        max-width: 250px !important;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1 !important
    }
</style>